import { useEffect, useState, useCallback } from 'react';
import api from '../axiosSetup';
import CustomNavbar from '../CustomNavbar';
import cfg from '../../config';

// Funktion statt Konstante: auf Modulebene wuerde der Rueckfallwert aus
// config.js eingefroren, bevor AppContext die Serverwerte uebernimmt.
// Die Schluessel muessen exakt den Werten entsprechen, die logAuditAction()
// in tbl_admin_audit_log.action schreibt. Zuvor standen hier Namen, die der
// Server nie verwendet (MEMBER_DELETE statt DELETE_MEMBER), weshalb die
// Tabelle den technischen Schluessel anzeigte statt einer Beschriftung.
const ACTION_LABELS = () => ({
  DELETE_MEMBER:        { label: `${cfg.memberTerm} gelöscht`,  badge: 'bg-danger' },
  ADMIN_RESET_PASSWORD: { label: 'Passwort zurückgesetzt', badge: 'bg-warning text-dark' },
  CHANGE_ROLE:          { label: 'Rolle geändert',         badge: 'bg-info text-dark' },
  FORM_UPDATE:          { label: 'Formular geändert',      badge: 'bg-primary' },
  SYSTEM_LOCK:          { label: 'Notsperre aktiviert',    badge: 'bg-danger' },
  SYSTEM_UNLOCK:        { label: 'Notsperre aufgehoben',   badge: 'bg-success' },
  DELETE_PERSONNEL_ENTRY: { label: 'Personalakten-Eintrag gelöscht', badge: 'bg-danger' },
});

const formatTs = (ts) => {
  if (!ts) return '–';
  return new Date(ts).toLocaleString('de-DE', { dateStyle: 'short', timeStyle: 'medium' });
};

const PAGE_SIZE = 50;

const ZRAuditLog = () => {
  const [rows, setRows]       = useState([]);
  const [total, setTotal]     = useState(0);
  const [page, setPage]       = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);
  const [search, setSearch]   = useState('');

  const load = useCallback(async (p) => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.get('/api/admin/audit-log', {
        params: { limit: PAGE_SIZE, offset: p * PAGE_SIZE },
      });
      setRows(res.data.rows || []);
      setTotal(res.data.total || 0);
    } catch {
      setError('Fehler beim Laden des Audit-Logs.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(page); }, [load, page]);

  const filtered = search.trim()
    ? rows.filter(r =>
        [r.action, r.details, r.adminFirstName, r.adminLastName, r.targetFirstName, r.targetLastName]
          .join(' ').toLowerCase().includes(search.toLowerCase())
      )
    : rows;

  const totalPages = Math.ceil(total / PAGE_SIZE);

  return (
    <div>
      <CustomNavbar />
      <div className="container-fluid px-3 px-md-4 mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2 className="mb-0">Admin-Aktions-Log</h2>
          <small className="text-muted">{total} Einträge gesamt</small>
        </div>
        <p className="text-muted small mb-3">
          DSGVO-Audit-Trail: wer hat wann welche administrative Aktion durchgeführt.
        </p>

        <div className="mb-3">
          <input
            className="form-control"
            placeholder="Suchen…"
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{ maxWidth: 360 }}
          />
        </div>

        {error && <div className="alert alert-danger">{error}</div>}

        {loading ? (
          <div className="text-center py-5"><div className="spinner-border text-warning" /></div>
        ) : (
          <>
            <div className="table-responsive">
              <table className="table table-dark table-hover table-sm align-middle">
                <thead>
                  <tr>
                    <th>Zeitpunkt</th>
                    <th>Aktion</th>
                    <th>Admin</th>
                    <th>Betrifft</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.length === 0 ? (
                    <tr><td colSpan={5} className="text-center text-muted py-4">Keine Einträge gefunden.</td></tr>
                  ) : filtered.map(r => {
                    const meta = ACTION_LABELS()[r.action] || { label: r.action, badge: 'bg-secondary' };
                    return (
                      <tr key={r.id}>
                        <td className="text-nowrap" style={{ fontSize: '0.82rem' }}>{formatTs(r.createdAt)}</td>
                        <td>
                          <span className={`badge ${meta.badge}`}>{meta.label}</span>
                        </td>
                        <td className="text-nowrap">
                          {r.adminFirstName
                            ? `${r.adminFirstName} ${r.adminLastName}`
                            : (r.adminName || `#${r.adminID}`)}
                        </td>
                        <td className="text-nowrap">
                          {r.targetFirstName
                            ? `${r.targetFirstName} ${r.targetLastName} (#${r.targetMemberID})`
                            : r.targetMemberID ? `#${r.targetMemberID}` : '–'
                          }
                        </td>
                        <td style={{ fontSize: '0.82rem', color: '#adb5bd' }}>{r.details || '–'}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {totalPages > 1 && (
              <div className="d-flex gap-2 align-items-center mt-2">
                <button
                  className="btn btn-sm btn-outline-secondary"
                  disabled={page === 0}
                  onClick={() => setPage(p => p - 1)}
                >
                  ‹ Zurück
                </button>
                <span className="small text-muted">Seite {page + 1} / {totalPages}</span>
                <button
                  className="btn btn-sm btn-outline-secondary"
                  disabled={page >= totalPages - 1}
                  onClick={() => setPage(p => p + 1)}
                >
                  Weiter ›
                </button>
              </div>
            )}
          </>
        )}
      </div>
      <br /><br />
    </div>
  );
};

export default ZRAuditLog;
